var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('el-loading',{attrs:{"text":"正在加载权限菜单...","fullscreen":"","background":'rgba(255, 255, 255, 0.8)'}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }